import api from './api.js'

// token请求
const client = process.env.AUTH_CLIENT
export function token(params){
    return api.post('/service-auth/oauth/token', {}, {params: client});
}
// 账号密码登录
export function getUserAndPassLogin(params){
    return api.post('/service-auth/oauth/login',params);
}

// 获取当前用户登录信息
export function getNewcurrent(params){
    return api.get('/service-center/api/v1/user/current',params);
}

// 卖家中心动态获取菜单
export function getMenuList(){
    return api.get('/service-center/api/v1/security/service/resource/self/service0010');
}

//实名认证
// 根据用户获取认证信息
export function getCredentials(params){
    return api.get('/service-center/api/v1/identity/personal/user',params);
}
//提交认证信息
export function submitCredentials(params){
    return api.post('/service-center/api/v1/identity/personal',params);
}
//更新认证信息
export function amendCredentials(params,uuid){
    return api.put('/service-center/api/v1/identity/personal/'+uuid,params);
}
// 获取字典组列表
export function getDictionaryGroup(params){
    return api.get('/service-center/api/v1/dictionary/group/list',params);
}
// 获取字典列表
export function getDictionaryItem(params){
    return api.get('/service-center/api/v1/dictionary/item',params);
}
// 获取字典分组详情
export function getDictionaryGroupDetail(id){
    return api.get('/service-center/api/v1/dictionary/group/'+id);
}
// 获取字典详情
export function getDictionaryDetail(id){
    return api.get('/service-center/api/v1/dictionary/item/'+id);
}
// 审批需求
export function auditDemand(params){
    return api.post('/resource-design/api/v1/demand/audit',params);
}

// 审批设计师
export function auditDesigner(params){
    return api.post('/resource-design/api/v1/designer/audit',params);
}
// 审批模型
export function auditModel(params){
    return api.post('/resource-design/api/v1/design/model/exam',params);
}
// 审批成品
export function auditProduct(params){
    return api.post('/resource-design/api/v1/design/product/exam',params);
}

// 分页获取设计师列表
export function designerListByPage(params){
    return api.get('/resource-design/api/v1/designer/query',params);
}

// 分页获取需求列表
export function demandListByPage(params){
    return api.get('/resource-design/api/v1/demand/query',params);
}

// 分页获取模型列表
export function modelListByPage(params){
    return api.get('/resource-design/api/v1/design/model/query',params);
}

// 分页获取作品列表
export function productListByPage(params){
    return api.get('/resource-design/api/v1/design/product/query',params);
}

// 查询服务商
export function getShopProvidersList(params){
    return api.get('/resource-print/api/v1/shopper/providers/nose/query',params);
}

// 查询服务商详情
export function getShopProvidersDetail(params){
    return api.get('/resource-print/api/v1/shopper/providers/nose/getProvidersSettledInfo',params);
}

// 服务商审核
export function updateExamineStatus(params){
    return api.get('/resource-print/api/v1/shopper/providers/updateExamineStatus',params);
}

// 服务商上架下架
export function changeOnAndOff(params){
    return api.get('/resource-print/api/v1/shopper/providers/changeOnAndOff',params);
}

// 模型订单查询接口
export function getModelOrderList(params){
    return api.get('/resource-order/api/v1/order/model/query',params);
}
// 模型详情接口
export function getModelDetail(params){
    return api.get(`/resource-design/api/v1/design/model/${params.uuid}`);
}
// 模型订单查询接口
export function getServiceOrderList(params){
    return api.get('/resource-order/api/v1/order/service/query',params);
}

// 根据字典id查询字典详情
export function getDictionaryItemDetails(uuid){
    return api.get(`/service-center/api/v1/dictionary/item/${uuid}`);
}

export function getDictionaryListDetails(uuid){
    return api.get(`/service-center/api/v1/dictionary/group/${uuid}`);
}

// 材料管理列表
export function getMaterialManagerList(params){
    return api.get('/resource-print/api/v1/material/manager/examine/query',params);
}

// 材料管理详情
export function getMaterialManagerDetail(params){
    return api.get('/resource-print/api/v1/material/manager/examine/getModelLandDetail',params);
}

// 材料管理审核
export function examineMaterialManager(params){
    return api.get('/resource-print/api/v1/material/manager/examineMaterialManager',params);
}

// 服务能力列表
export function getServiceabilityList(params){
    return api.get('/resource-print/api/v1/serviceability/examine/query',params);
}

// 服务能力详情
export function getServiceabilityDetail(params){
    return api.get('/resource-print/api/v1/serviceability/examine/getDetail',params);
}

// 服务能力审核
export function examineServiceability(params){
    return api.get('/resource-print/api/v1/serviceability/examine/examineServiceability',params);
}

// 成果展示列表
export function getPresentationList(params){
    return api.get('/resource-print/api/v1/presentation/examine/query',params);
}

// 成果展示详情
export function getPresentationDetail(params){
    return api.get('/resource-print/api/v1/presentation/findMaterialDetail',params);
}

// 成果展示审核
export function examinePresentation(params){
    return api.get('/resource-print/api/v1/presentation/examine/examinePresentation',params);
}


// 文件上传
export function uploadFile(params){
    return api.post('/service-center/upload/file/single',params);
}

// 设置服务商推荐位
export function setProvidersSort(params){
    return api.get('/resource-print/api/v1/shopper/providers/setProvidersSort',params);
}

// 设置商家推荐位
export function setShopSettledSort(params){
    return api.get('/resource-print/api/v1/shop/settled/setShopSettledSort',params);
}

// 分页获取评价列表
export function getEvaluationList(params){
    return api.get(`/resource-order/api/v1/order/evaluation/adminQuery`,params);
}


//管理员后台分页获取订单投诉
export function getBackComplainList(params){
    return api.get('/resource-order/api/v1/order/complain/backQuery',params);
}

//处理投诉
export function dealComplain(params){
    return api.post(`/resource-order/api/v1/order/complain/deal/`,params);
}


// 打印订单
export function getPrintOrderList(params){
    return api.get('/resource-order/api/v1/order/print/proTable',params);
}

//（融云用）根据目标id获取用户或者企业管理员
export function getRongCloudUser(uuid){
    return api.get('/service-center/api/v1/user/rongCloud/' + uuid);
}

export function getPrintOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/print/${params.uuid}`);
}

export function findBuyerPrintOrderDetail(params){
    return api.get('/resource-print/api/v1/buyer/print/order/findBuyerPrintOrderDetail',params);
}

export function getAddressDetail(params){
    return api.get(`/service-center/api/v1/address/${params.uuid}`);
}

export function findInvoiceInfo(params){
    return api.get(`/service-center/api/v1/invoice/title/${params.uuid}`);
}

// 设计订单列表
export function getDesignOrderList(params){
    return api.get('/resource-order/api/v1/order/design/proTable',params);
}

export function getDesignOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/design/${params.uuid}`);
}
// 平台垫付订单平台确认
export function platformAdvancesConfirm(orderNo){
    return api.get(`/resource-order/api/v1/order/base/platformAdvancesConfirm/${orderNo}`);
}

// 平台垫付订单平台确认支付
export function platformAdvancesConfirmPay(orderNo){
    return api.get(`/resource-order/api/v1/order/base/platformAdvancesConfirmPay/${orderNo}`);
}

export function getDesignInfoDetail(params){
    return api.get(`/resource-design/api/v1/demand/portal/${params.uuid}`);
}

export function getDesignerDemandFile(params){
    return api.get('/resource-design/api/v1/designer/demand/getDesignerDemandFile',params);
}

export function findChooseDemandOffer(params){
    return api.get('/resource-design/api/v1/demand/findChooseDemandOffer',params);
}

export function findUpdateRemark(params){
    return api.get('/resource-design/api/v1/designer/demand/findUpdateRemark',params);
}

// 服务订单查询详情
export function getServiceOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/service/${params.uuid}`);
}

// 查询用户
export function getUserInfo(uuid){
    return api.get('/service-center/api/v1/user/' + uuid);
}

// 根据数据字典id查询材料类型信息
export function findTypeListByGroupUuid(params){
    return api.get('/resource-order/api/v1/material/type/findTypeListByGroupUuid',params);
}

// 根据主键查询材料类型信息
export function get(params){
    return api.get('/resource-order/api/v1/material/type/get',params);
}

//根据订单获取开票信息
export function getIssueInvoiceByOrderId(uuid){
    return api.get(`/resource-order/api/v1/issue/invoice/getIssueInvoiceByOrderId/${uuid}`);
}

//分页获取店铺入驻信息
export function getShopSettledList(params){
    return api.get('/resource-print/api/v1/shop/settled/query',params);
}

//获取详情信息
export function getShopSettledInfo(uuid){
    return api.get(`/resource-print/api/v1/shop/settled/${uuid}`,);
}

//审核
export function auditShopper(params){
    return api.post('/resource-print/api/v1/shop/settled/audit',params);
}


// 保存活动
export function saveActivityInfo(params){
    return api.post('/resource-activity/api/v1/activity/manage',params);
}

// 活动发布
export function publishActivity(params){
    return api.get('/resource-activity/api/v1/activity/manage/publishActivity',params);
}

// 编辑
export function editActivityInfo(params){
    return api.post(`/resource-activity/api/v1/activity/manage/${params.uuid}`,params);
}

// 查询活动列表
export function getActivityList(params){
    return api.get('/resource-activity/api/v1/activity/manage/query',params);
}

// 查询活动赛道列表
export function getActivityWayList(params){
    return api.get('/resource-activity/api/v1/activity/way/list',params);
}

// 查询活动列表
export function getActivityInfo(params){
    return api.get('/resource-activity/api/v1/activity/manage/list',params);
}

// 查询活动类别
export function getActivityTypeList(params){
    return api.get("/resource-activity/api/v1/activity/manage/getActivityTypeList",params);
}

// 删除活动信息
export function deleteActivityInfo(uuid){
    return api.del(`/resource-activity/api/v1/activity/manage/${uuid}`);
}

// 获取模板信息
export function getActivityTemplateList(){
    return api.get('/resource-activity/api/v1/activity/manage/getActivityTemplateList');
}

// 获取名称信息
export function getActivityTemplateStyleList(params){
    return api.get('/resource-activity/api/v1/activity/manage/getActivityTemplateStyleList',params);
}

// 获取名称信息
export function getActivityDetail(uuid){
    return api.get(`/resource-activity/api/v1/activity/manage/${uuid}`);
}

// 查询所有用户信息
export function getActivityUserInfo(){
    return api.get("/resource-activity/api/v1/judge/library/getUserInfo");
}

// 保存用户权限
export function saveJudge(params){
    return api.post("/resource-activity/api/v1/judge/library",params);
}

// 查询信息
export function findJudgeList(params){
    return api.get("/resource-activity/api/v1/judge/library/query",params);
}

// 查询信息
export function getJudgeList(params){
    return api.get("/resource-activity/api/v1/judge/library/list",params);
}

// 停用
export function stopJudgeInfo(params){
    return api.get("/resource-activity/api/v1/judge/library/stopJudgeInfo",params);
}

// 查询信息
export function startJudgeInfo(params){
    return api.get("/resource-activity/api/v1/judge/library/startJudgeInfo",params);
}

// 查询详情信息
export function getJudgeLibraryDetail(params){
    return api.get("/resource-activity/api/v1/judge/library/getJudgeLibraryDetail",params);
}

// 获取评委、领导关联活动列表
export function getActivityJudgeList(params){
    return api.get("/resource-activity/api/v1/activity/judge/query",params);
}

// 保存评委、领导关联活动信息
export function saveActivityJudge(params){
    return api.post("/resource-activity/api/v1/activity/judge",params);
}

// 删除评委、领导关联活动信息
export function deleteActivityJudge(params){
    return api.get("/resource-activity/api/v1/activity/judge/deleteActivityJudge",params);
}

// 获取评委、领导关联活动信息
export function getActivityJudgeInfo(params){
    return api.get("/resource-activity/api/v1/activity/judge/getActivityJudgeInfo",params);
}
// 发货
export function updateDeliverGoodsOrder(params) {
    return api.post('/resource-order/api/v1/deliverGoods/updateOrderBaseInfo',params);
}

// 实时物流查询
export function getLogisticsTrack(params) {
    return api.get('/resource-order/api/v1/logistics/kuaidi100/queryTrack',params);
}

// 查询作品审核列表
export function getWorksList(params){
    return api.get('/resource-activity/api/v1/activity/works/query',params);
}

// 导出作品审核列表
export function exportWorksList(params){
    return api.get('/resource-activity/api/v1/activity/works/list',params);
}

// 查询作品详情信息
export function getWorksDetail(uuid){
    return api.get(`/resource-activity/api/v1/activity/works/${uuid}`);
}

// 提交审核
export function auditWorks(params){
    return api.post('/resource-activity/api/v1/activity/works/audit',params);
}

// 报名列表
export function getSignList(params){
    return api.get('resource-activity/api/v1/activity/sign/query',params);
}

// 报名列表
export function getAllSignList(params){
    return api.get('resource-activity/api/v1/activity/sign/list',params);
}

// 评分信息
export function getWorksScoreInfo(params){
    return api.get('resource-activity/api/v1/activity/works/review/getWorksScoreInfo',params);
}

// 领导信息
export function getExamineWorksList(params){
    return api.get('resource-activity/api/v1/activity/works/leader/getExamineWorksList',params);
}

// 获取奖项列表
export function getAwardList(params){
    return api.get('resource-activity/api/v1/activity/award/list',params);
}

// 保存获奖信息
export function saveWorksAwardInfo(worksUuid,awardUuid){
    return api.post(`resource-activity/api/v1/activity/works/award/${worksUuid}/${awardUuid}`);
}

// 移除获奖信息
export function removeAward(uuid){
    return api.del(`resource-activity/api/v1/activity/works/${uuid}`);
}

// 删除评委或者领导
export function removeJudgeLibrary(uuid){
    return api.del(`resource-activity/api/v1/judge/library/${uuid}`);
}


// 商品分类列表
export function getShopCategoryList(params){
    return api.get('/resource-print/api/v1/shop/category/query',params);
}
// 保存商品分类信息
export function saveShopCategory(params){
    return api.post('/resource-print/api/v1/shop/category',params);
}
// 更新商品分类信息
export function updateShopCategory(params,uuid){
    return api.put('/resource-print/api/v1/shop/category/'+uuid,params);
}
// 删除商品分类信息
export function deleteShopCategory(uuid){
    return api.del(`/resource-print/api/v1/shop/category/${uuid}`);
}
// 获取商品分类信息
export function getShopCategoryInfo(uuid){
    return api.get(`/resource-print/api/v1/shop/category/detail?uuid=${uuid}`,);
}

// 获取平台商品分类树
export function typetree(params){
    return api.get(`/resource-print/api/v1/shop/category/typetree`,params);
}
// 平台商品规格列表
export function getShopStandardList(params){
    return api.get('/resource-print/api/v1/shop/standard/query',params);
}
// 保存平台商品规格信息
export function saveShopStandard(params){
    return api.post('/resource-print/api/v1/shop/standard',params);
}
// 删除平台商品规格信息
export function deleteShopStandard(uuid){
    return api.del(`/resource-print/api/v1/shop/standard/${uuid}`);
}

// 商家上架下架
export function shopSettledOnOrOff(params){
    return api.get('/resource-print/api/v1/shop/settled/shopSettledOnOrOff',params);
}

// 获取平台商品规格信息
export function getShopStandardInfo(uuid){
    return api.get(`/resource-print/api/v1/shop/standard/detail?uuid=${uuid}`,);
}
// 商品类目属性列表
export function getShopStandardListAll(params){
    return api.get('/resource-print/api/v1/shop/standard/list',params);
}

//设计师级别删除
export function deleteLevel(params){
    return api.del(`/resource-design/api/v1/designer/level/delete/${params.uuid}`);
}

//保存设计师级别
export function saveLevel(params){
    return api.post('/resource-design/api/v1/designer/level/save',params);
}

//查询设计师级别列表
export function designerLevelListByPage(params){
    return api.get('/resource-design/api/v1/designer/level/query',params);
}

//根据id查询设计师级别
export function findDesignerLevelById(params){
    return api.get(`/resource-design/api/v1/designer/level/getLevel/${params.uuid}`);
}

//根据类型查询设计师级别是否有重复
export function getDuplicateName(params){
    return api.post('/resource-design/api/v1/designer/level/getDuplicateName/',params);
}

// 模板库接口
// 分页查询列表
export function getTemplateList(params){
    return api.get('/resource-activity/api/v1/activity/template/query',params);
}

// 查询列表
export function getTemplateInfo(params){
    return api.get('/resource-activity/api/v1/activity/template/list',params);
}

// 保存模板
export function saveTemplateInfo(params){
    return api.post('/resource-activity/api/v1/activity/template',params);
}

// 查询模板详情
export function findTemplateInfo(uuid){
    return api.get(`/resource-activity/api/v1/activity/template/${uuid}`);
}

// 修改模板
export function updateTemplateInfo(params){
    return api.post(`/resource-activity/api/v1/activity/template/${params.uuid}`,params);
}

// 删除
export function deleteTemplateInfo(uuid){
    return api.del(`/resource-activity/api/v1/activity/template/${uuid}`);
}

// 皮肤库接口
export function getTemplateStyleList(params){
    return api.get('/resource-activity/api/v1/activity/template/style/query',params);
}

// 查询列表
export function getTemplateStyleInfo(params){
    return api.get('/resource-activity/api/v1/activity/template/style/list',params);
}

// 保存模板
export function saveTemplateStyleInfo(params){
    return api.post('/resource-activity/api/v1/activity/template/style',params);
}

// 查询模板详情
export function findTemplateStyleInfo(uuid){
    return api.get(`/resource-activity/api/v1/activity/template/style/${uuid}`);
}

// 修改模板
export function updateTemplateStyleInfo(params){
    return api.post(`/resource-activity/api/v1/activity/template/style/${params.uuid}`,params);
}

// 删除
export function deleteTemplateStyleInfo(uuid){
    return api.del(`/resource-activity/api/v1/activity/template/style/${uuid}`);
}
// 商品列表
export function getGoodsList(params){
    return api.get('/resource-print/api/v1/goods/query',params);
}
// 保存商品信息
export function saveGoods(params){
    return api.post('/resource-print/api/v1/goods',params);
}
// 更新商品信息
export function updateGoods(params,uuid){
    return api.put('/resource-print/api/v1/goods/'+uuid,params);
}
// 更新商品SEO信息
export function updateGoodsSeoInfo(params){
    return api.post('/resource-print/api/v1/goods/updateGoodsSeoInfo',params);
}
// 删除商品信息
export function deleteGoods(uuid){
    return api.del(`/resource-print/api/v1/goods/${uuid}`);
}
// 获取商品信息
export function getGoodsInfo(uuid){
    return api.get(`/resource-print/api/v1/goods/detail?uuid=${uuid}`);
}
// 更新商品状态信息
export function updateGoodsStatus(params){
    return api.put('/resource-print/api/v1/goods/updateStatus',params);
}
// 更新商品状态信息
export function updateGoodsInfoStatus(params){
    return api.post('/resource-print/api/v1/goods/updateGoodsInfoStatus',params);
}
// 商品列表
export function getGoodsAuditList(params){
    return api.get('/resource-print/api/v1/goods/audit/query',params);
}
// 商品审核
export function goodsAudit(params){
    return api.post('/resource-print/api/v1/goods/audit/goodsAudit',params);
}
// 查看商品审核
export function goodsAuditDetail(uuid){
    return api.get(`/resource-print/api/v1/goods/audit/detail?uuid=${uuid}`);
}



// 商品推荐分类查询接口
export function getRecommendCategoryList(params){
    return api.get('/resource-print/api/v1/shop/recommend/query',params);
}

// 保存商品推荐分类接口
export function saveRecommendCategory(params){
    return api.post('/resource-print/api/v1/shop/recommend/',params);
}

// 修改商品推荐分类接口
export function modifyRecommendCategory(uuid, params){
    return api.put(`/resource-print/api/v1/shop/recommend/${uuid}`,params);
}

// 商品推荐分类修改状态接口
export function modifyRecommendCategoryStatus(params){
    return api.post(`/resource-print/api/v1/shop/recommend/change/${params.uuid}/${params.survival}`);
}
// 推荐顺序修改接口
export function modifyRecommendCategoryOrder(params){
    return api.post(`/resource-print/api/v1/shop/recommend/sort/${params.uuid}/${params.sort}`,params);
}

// 查询商品推荐分类详情接口
export function getRecommendCategoryDetail(uuid){
    return api.get(`/resource-print/api/v1/shop/recommend/${uuid}`);
}

// 删除商品推荐分类
export function deleteRecommendCategory(uuid){
    return api.del(`/resource-print/api/v1/shop/recommend/${uuid}`);
}

// 根据一级分类分页获取商品列表接口
export function getRecommendGoodsListByPlatformFirstTypeUuid(params){
    return api.get('/resource-print/api/v1/goods/recommendedQuery',params);
}

// 获取推荐商品列表接口
export function getRecommendGoodsList(params){
    return api.get('/resource-print/api/v1/shop/recommend/goods/list',params);
}

// 商品推荐保存接口
export function saveRecommendGoods(recommendUuid, params){
    return api.post(`/resource-print/api/v1/shop/recommend/goods/${recommendUuid}`,params);
}

// 推荐顺序修改接口
export function modifyRecommendGoodsOrder(params){
    return api.post(`/resource-print/api/v1/shop/recommend/goods/sort/${params.uuid}/${params.sort}`,params);
}

// 商城列表
export function getOrderShopList(params){
    return api.get('/resource-order/api/v1/order/shop/query',params);
}

// 修改商城订单信息
export function getOrderShopInfo(params) {
    return api.get('/resource-order/api/v1/order/shop/getOrderShopInfo',params);
}

// 获取模型订单详情
export function getModelOrderDetail(params){
    return api.get(`/resource-order/api/v1/order/model/${params.uuid}`,params);
}

// 获取活动所有评分打分情况
export function getJudgesWorksScoreInfo(params) {
    return api.get('/resource-activity/api/v1/activity/judge/getJudgesWorksScoreInfo', params);
}
// 首页统计
export function indexCountNumPrint(){
    return api.get('/resource-print/api/v1/material/manager/nose/indexCountNum');
}

// 首页统计
export function indexCountNumDesign(){
    return api.get('/resource-design/api/v1/design/model/indexCountNum');
}

// 销售额统计
export function indexSellerCountPrint(){
    return api.get('/resource-order/api/v1/order/base/indexCountNum');
}

// 小程序查询
export function appletQuery(params){
    return api.get('/resource-applet/api/v1/applet/order/proTable', params);
}
// 小程序打印完成
export function finished(orderUuid) {
    return api.post(`/resource-applet/api/v1/applet/order/finished/${orderUuid}`)
}

export function appletGet(uuid) {
    return api.get(`/resource-applet/api/v1/applet/order/${uuid}`);
}
// 小程序发票
export function appletInvoiceQuery(params){
    return api.get("/resource-applet/api/v1/applet/order/invoice/proTable",params);
}

export function appletInvoiceInfo(uuid){
    return api.get(`/resource-applet/api/v1/applet/order/invoice/${uuid}`);
}

export function voucher(uuid, params){
    return api.post(`/resource-applet/api/v1/applet/order/invoice/voucher/${uuid}`,params);
}

// 小程序行业案例
export  function appletCaseQuery(params){
    return api.get("/resource-applet/api/v1/case/proTable",params);
}

// 小程序留言
export  function messageQuery(params){
    return api.get("/resource-applet/api/v1/message/proTable",params);
}

export  function messageDealBatch(params){
    return api.post("/resource-applet/api/v1/message/dealBatch",params);
}

export  function messageDelete(params){
    return api.del("/resource-applet/api/v1/message/cancel",params)
}

export  function getMessageInfo(uuid){
    return api.get(`/resource-applet/api/v1/message/${uuid}`);
}
//订单物流信息
export function transport(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/transport/${orderUuid}`,params)
}
//上传模型文件
export function deliver(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/deliver/${orderUuid}`, params)
}
//上传设计文件
export function confirmOrder(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/confirm/${orderUuid}`, params)
}
//导出excel
export function exportTable(orderUuid, params) {
    return api.excelExport(`/resource-applet/api/v1/applet/order/export`, {
        params
    })
}

//导出excel
export function exportSxTable(orderUuid, params) {
    return api.excelExport(`/resource-applet/api/v1/applet/order/sx/export`, {
        params
    })
}

//订单修改意见
export function listAdvise(orderUuid) {
    return api.get(`/resource-applet/api/v1/applet/order/advise/${orderUuid}`);
}
//订单拒绝原因
export function listDeliver(orderUuid) {
    return api.get(`/resource-applet/api/v1/applet/order/deliver/list?orderUuid=${orderUuid}`)
}
//删除
export function caseCancel(params){
    return api.del("/resource-applet/api/v1/case/cancel",params)
}
//发布
export  function publish(params){
    return api.post("/resource-applet/api/v1/case/publish",params);
}
export async function caseSave(params){
    return api.post('/resource-applet/api/v1/case/save',params)
}
// 图片上传
export function uploadPicture(params){
    return api.post('/service-center/upload/file/single',params);
}

export function caseGet(uuid){
    return api.get(`/resource-applet/api/v1/case/${uuid}`);
}

// 分页获取操作日志列表
export function sysOperLogListByPage(params){
    return api.get('/resource-visitor/api/v1/sys/oper/log/info/query',params);
}

// 设计师启用禁用
export function changeDesignerOnAndOff(params){
    return api.get('/resource-design/api/v1/designer/changeOnAndOff',params);
}

// 设计师推荐位
export function setDesignerSort(params){
    return api.get('/resource-design/api/v1/designer/designerSort',params);
}
// 服务推荐位
export function setServiceSort(params){
    return api.get('/resource-print/api/v1/serviceability/examine/serviceabilitySort',params);
}
// 模型推荐位
export function setModelSort(params){
    return api.get('/resource-design/api/v1/design/model/modelSort',params);
}

// 材料推荐位
export function setMaterialSort(params){
    return api.get('/resource-print/api/v1/material/manager/examine/materialSort',params);
}

// 圈子管理
export function circleQuery(params){
    return api.get('/resource-maker/api/v1/circleInfo/query',params);
}

export function getCircle(uuid){
    return api.get(`/resource-maker/api/v1/circleInfo/${uuid}`);
}

export function deleteCircle(params){
    return api.del('/resource-maker/api/v1/circleInfo/cancel',params);
}

export function saveCircle(params){
    return api.post('/resource-maker/api/v1/circleInfo/save',params);
}

export function auditCircle(params){
    return api.post('/resource-maker/api/v1/circleInfo/audit',params);
}

// 取消服务商推荐
export function removeProvidersSort(params){
    return api.get('/resource-print/api/v1/shopper/providers/removeProvidersSort',params);
}

// 创客圈动态管理
// 列表
export function dynamicQuery(params){
    return api.get('/resource-maker/api/v1/circle/dynamic/query',params);
}
// 审核
export function dynamicAudit(uuid,status,params){
    return api.post(`/resource-maker/api/v1/circle/dynamic/${uuid}/${status}`,params);
}
// 删除
export function dynamicDelete(uuid,params){
    return api.del(`/resource-maker/api/v1/circle/dynamic/${uuid}`,params);
}

// 删除
export function dynamicDeleteList(params){
    return api.del('/resource-maker/api/v1/circle/dynamic/cancel',params);
}

// 删除
export function dynamicGet(uuid){
    return api.get(`/resource-maker/api/v1/circle/dynamic/${uuid}`);
}

// 获取折扣设置列表
export function getDiscountSettingList(params){
    return api.get('/resource-order/api/v1/discount/query',params);
}
// 保存折扣设置
export function saveDiscountSetting(params){
    return api.post('/resource-order/api/v1/discount',params);
}
// 更新折扣设置
export function updateDiscountSetting(params,uuid){
    return api.put('/resource-order/api/v1/discount/'+uuid,params);
}
// 删除折扣设置
export function deleteDiscountSetting(uuid){
    return api.del(`/resource-order/api/v1/discount/${uuid}`);
}
// 获取折扣设置
export function getDiscountInfo(uuid){
    return api.get(`/resource-order/api/v1/discount/detail?uuid=${uuid}`,);
}

// 设计师列表
export function designerList(params){
    return api.get('/resource-design/api/v2/designer/list',params);
}

// 查询所有服务商
export function getServiceList(params){
    return api.get('/resource-print/api/v1/shopper/providers/nose/list',params);
}

// 查询佣金
export function findCommission(uuid){
    return api.get(`/resource-order/api/v1/commission/${uuid}`);
}

// 删除佣金
export function deleteCommission(uuid){
    return api.del(`/resource-order/api/v1/commission/${uuid}`);
}

export function saveCommission(params){
    return api.post('/resource-order/api/v1/commission/save',params);
}

export function queryCommissionList(params){
    return api.get('/resource-order/api/v1/commission/query',params);
}

export function synCommission(params){
    return api.get('/resource-order/api/v1/commission/synCommission',params);
}
//砂芯
// 小程序查询
export function appletQuerySx(params){
    return api.get('/resource-applet/api/v1/applet/order/sx/proTable', params);
}
// 小程序打印完成
export function finishedSx(orderUuid) {
    return api.post(`/resource-applet/api/v1/applet/order/sx/finished/${orderUuid}`)
}

// 小程序设计详情
export function findConfirmInfo(params) {
    return api.get('/resource-applet/api/v1/applet/order/confirm/list',params)
}
// 小程序设计详情
export function findConfirmInfoSx(params) {
    return api.get('/resource-applet/api/v1/applet/order/confirm/sx/list',params)
}

export function appletGetSx(uuid) {
    return api.get(`/resource-applet/api/v1/applet/order/sx/${uuid}`);
}
// 小程序发票
export function appletInvoiceQuerySx(params){
    return api.get("/resource-applet/api/v1/applet/order/invoice/sx/proTable",params);
}

export function appletInvoiceInfoSx(uuid){
    return api.get(`/resource-applet/api/v1/applet/order/invoice/sx/${uuid}`);
}

export function voucherSx(uuid, params){
    return api.post(`/resource-applet/api/v1/applet/order/invoice/sx/voucher/${uuid}`,params);
}

// 小程序行业案例
export  function appletCaseQuerySx(params){
    return api.get("/resource-applet/api/v1/case/sx/proTable",params);
}

// 小程序留言
export  function messageQuerySx(params){
    return api.get("/resource-applet/api/v1/message/sx/proTable",params);
}

export  function messageDealBatchSx(params){
    return api.post("/resource-applet/api/v1/message/sx/dealBatch",params);
}

export  function messageDeleteSx(params){
    return api.del("/resource-applet/api/v1/message/sx/cancel",params)
}

export  function getMessageInfoSx(uuid){
    return api.get(`/resource-applet/api/v1/message/sx/${uuid}`);
}

//订单物流信息
export function transportSx(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/sx/transport/${orderUuid}`,params)
}
//上传模型文件
export function deliverSx(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/sx/deliver/${orderUuid}`, params)
}
//上传设计文件
export function confirmOrderSx(orderUuid, params) {
    return api.post(`/resource-applet/api/v1/applet/order/sx/confirm/${orderUuid}`, params)
}
//订单修改意见
export function listAdviseSx(orderUuid) {
    return api.get(`/resource-applet/api/v1/applet/order/advise/sx/${orderUuid}`);
}
//订单拒绝原因
export function listDeliverSx(orderUuid) {
    return api.get(`/resource-applet/api/v1/applet/order/deliver/sx/list?orderUuid=${orderUuid}`)
}
//删除
export function caseCancelSx(params){
    return api.del("/resource-applet/api/v1/case/sx/cancel",params)
}
//发布
export  function publishSx(params){
    return api.post("/resource-applet/api/v1/case/sx/publish",params);
}
export async function caseSaveSx(params){
    return api.post('/resource-applet/api/v1/case/sx/save',params)
}
export function caseGetSx(uuid){
    return api.get(`/resource-applet/api/v1/case/sx/${uuid}`);
}

//分页获取集采、积分活动列表
export function activitiesListByPage(params){
    return api.get("/resource-order/api/v1/order/activities/query",params);
}

//获取活动比赛list
export function activitiesMatchList(params){
    return api.get("/resource-activity/api/v1/activity/match/query",params);
}
export function saveActivityMatch(params){
    return api.post("/resource-activity/api/v1/activity/match",params);
}
export function deleteActivityMatch(uuid){
    return api.del(`/resource-activity/api/v1/activity/match/delete/${uuid}`);
}


//获取集采、积分活动列表
export function activitiesList(params){
    return api.get("/resource-order/api/v1/order/activities/list",params);
}

//获取集采、积分活动详情
export function getActivitiesDetails(uuid){
    return api.get(`/resource-order/api/v1/order/activities/${uuid}`);
}

//保存集采、积分活动草稿
export function saveActivities(params){
    return api.post("/resource-order/api/v1/order/activities/save",params);
}

//发布集采、积分活动
export function publishActivities(params){
    return api.post("/resource-order/api/v1/order/activities/publish",params);
}

// 删除集采、积分活动信息
export function delActivities(uuid){
    return api.del(`/resource-order/api/v1/order/activities/deleteActivities?uuid=${uuid}`,);
}

//分页获取集采、积分店铺列表
export function activitiesStoreListByPage(params){
    return api.get("/resource-order/api/v1/order/activityStoreInfo/query",params);
}

//获取集采、积分店铺列表
export function activitiesStoreList(params){
    return api.get("/resource-order/api/v1/order/activityStoreInfo/list",params);
}

//分页获取集采、积分商品列表
export function activitiesGoodsListByPage(params){
    return api.get("/resource-order/api/v1/order/activityGoodsInfo/adminQuery",params);
}

//获取集采、积分商品列表
export function activitiesGoodsList(params){
    return api.get("/resource-order/api/v1/order/activityGoodsInfo/list",params);
}

//获取集采、积分商品详情
export function getActivitiesGoodsDetails(uuid){
    return api.get(`/resource-order/api/v1/order/activityGoodsInfo/${uuid}`);
}

//审核集采、积分活动
export function auditActivitiesGoods(params){
    return api.post("/resource-order/api/v1/order/activityGoodsInfo/audit",params);
}

//分页获取店铺总积分列表
export function activitiesStorePointListByPage(params){
    return api.get("/resource-order/api/v1/order/activityStorePoint/adminQuery",params);
}

//获取店铺总积分列表
export function activitiesStorePointList(params){
    return api.get("/resource-order/api/v1/order/activityStorePoint/list",params);
}

//店铺积分兑换
export function exchangeActivitiesStore(params){
    return api.post("/resource-order/api/v1/order/activityStorePoint/exchange",params);
}

// 分页获取用户积分列表
export function userPointsListByPage(params){
    return api.get('/service-center/api/v1/user/points/record/search',params);
}
// 分页获取用户积分明细列表
export function userPointsRecordListByPage(params){
    return api.get('/service-center/api/v1/user/points/record/query',params);
}

// 分页获取操作日志列表
export function systemLoginLogListByPage(params){
    return api.get('/service-center/api/v1/loginLog/query',params);
}

// 分页获取操作日志列表
export function deleteLoginLog(params){
    return api.del('/service-center/api/v1/loginLog/deleteByIds',params);
}

// 获取登录日志分析
export function analyseLoginLog(params){
    return api.get('/service-center/api/v1/loginLog/analyse',params);
}

// 获取操作日志分析
export function analyseOperLog(params){
    return api.get('/resource-visitor/api/v1/sys/oper/log/info/analyse',params);
}

//实时概况统计
export function getRealTimeStatisticData(moduleType){
    return api.get('/resource-order/api/v1/order/base/getRealTimeStatisticData?moduleType='+moduleType);
}
//交易概况统计
export function getTransactionStatisticData(params){
    return api.get('/resource-order/api/v1/order/base/getTransactionStatisticData', params);
}
// 设计师排行列表
export function findDesignerInfo(params){
    return api.get('/resource-design/api/v1/designer/findDesignerInfo', params);
}
// 服务商排行榜
export function findEnterPriseInfoList(params){
    return api.get('/resource-print/api/v1/print/enterPrise/findEnterPriseInfoList',params);
}
// 模型数量
export function modelNumber(params){
    return api.get('/resource-design/api/v1/design/model/modelNumber',params);
}
// 服务商信息
export function getShopProvidersCount(params){
    return api.get('/resource-print/api/v1/shopper/providers/getShopProvidersCount',params);
}
// 企业认证信息
export function findEnterPriseIdentityCount(params){
    return api.get('/service-center/api/v1/identity/enterprise/findEnterPriseIdentityCount',params);
}

export function findPersonalIdentityCount(params){
    return api.get('/service-center/api/v1/identity/personal/findPersonalIdentityCount',params);
}
// 商品列表
export function queryGoodsList(params){
    return api.get('/resource-print/api/v1/goods/queryGoodsInfo',params);
}
// 服务列表
export function queryServiceList(params){
    return api.get('/resource-print/api/v1/serviceability/queryServiceList',params);
}
// 材料列表
export function queryMaterialList(params){
    return api.get('/resource-print/api/v1/material/manager/queryMaterialList',params);
}
// 模型列表
export function queryDesignModelList(params){
    return api.get('/resource-design/api/v1/design/model/queryDesignModelList',params);
}
//提交作品获奖证书
export function submitCertificate(params) {
    return api.post('/resource-activity/api/v1/activity/works/certificate',params);
}
//查询签约企业
export function getContractorList(params) {
    return api.get('/service-center/api/v1/user/member/query',params);
}
//更新签约状态
export function updateContractor(uuid){
    return api.post(`/service-center/api/v1/user/member/contract/${uuid}`)
}



// WEBPACK FOOTER //
// ./src/utils/interface.js